import { importProvidersFrom, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { AuthorizationPageComponent } from '@modules/authorization/components';
import { effects, reducers } from '@modules/company-page/store';

const routes: Routes = [
  {
    path: '',
    component: AuthorizationPageComponent,
    providers: [
      importProvidersFrom(StoreModule.forFeature('companyPage', reducers), EffectsModule.forFeature([...effects])),
    ],
    children: [
      {
        path: 'forgot-password',
        title: 'forgotPasswordPage.titleTab',
        data: {
          title: 'forgotPasswordPage.title',
          backButtonTitle: 'forgotPasswordPage.backButtonPageName',
        },
        loadComponent: () =>
          import('./components/forgot-password-page/forgot-password-page.component').then(
            (mod) => mod.ForgotPasswordPageComponent
          ),
      },
      {
        path: 'reset-password',
        title: 'resetPasswordPage.titleTab',
        data: {
          title: 'resetPasswordPage.title',
          backButtonTitle: 'resetPasswordPage.backButtonPageName',
        },
        loadComponent: () =>
          import('./components/reset-password-page/reset-password-page.component').then(
            (mod) => mod.ResetPasswordPageComponent
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthorizationRoutingModule {}
